<script setup lang="ts">
    import { defineAsyncComponent } from 'vue';
    import TopBannerRight from '../components/oferta/TopBannerRight.vue' 
    import FormarBloque from '../components/oferta/FormarBloqueNeo.vue';
    const MtrPlanEstudios = defineAsyncComponent(() => import('../components/oferta/MtrPlanEstudios.vue')) ; 
    const VerModelo = defineAsyncComponent(() => import('../components/oferta/VerModelo.vue')) ;
const PoliticaIA = defineAsyncComponent(() => import('../components/oferta/PoliticaIA.vue'))
    const CalendarioOferta = defineAsyncComponent(() => import('../components/oferta/CalendarioOferta.vue'))
    // const DescargaFolleto = defineAsyncComponent(() => import('../components/oferta/DescargaFolleto.vue')) ; 
    // const MtrModEjec = defineAsyncComponent(() => import('../components/oferta/MtrModEjec.vue')) ; 
    // const EgresadosHuma = defineAsyncComponent(() => import('../components/oferta/EgresadosHuma.vue')) ;
</script>

<template>
    <TopBannerRight
        :img="'background-image: url(../../pagesImages/banner-fiscal1.jpg);'"
        :nivel="'Maestr&iacute;a en'"
        :carrera="'Derecho Fiscal'"
        :frase="'La justicia es la voluntad constante y perpetua de dar a cada hombre lo que merece'"
        :autor="'Domitus Ulpian'"
    />

    <FormarBloque
        :img="'../../pagesImages/alumno-maestria-derecho-fiscal.webp'"
        :link="'/requisitos-maestria'"
        alt="Estudiante de Maestría en Derecho Fiscal"
        :frase="'Domina el sistema tributario mexicano y conceptos como sucesión causal, consecuencias obligacionales y patrimoniales para crear estrategias fiscales efectivas'"
        :testo1="'La Maestría en Derecho Fiscal desarrolla conocimientos avanzados y brinda las herramientas prácticas para interpretar y aplicar las normas jurídicas que regulan los ingresos del Estado, así como para diseñar estrategias fiscales inteligentes que beneficien a los contribuyentes.'"
        :testo3="'Profesionales del Derecho y contadores, interesados en profundizar en el ámbito fiscal, con una visión integral de la planeación tributaria, el pago de contribuciones y el manejo legal de bienes y mercancías.'"
    />


    <div class="flex items-center justify-center my-10">
    </div>

    <MtrPlanEstudios
        :ejecutivo="true"
    
    />

    

    <VerModelo esco=""
    ejec="/pagesImages/Programas/Maestria/Plan_De_Estudios_Derecho_Fiscal_Web.webp,/pagesImages/Programas/Maestria/Plan_De_Estudios_Derecho_Fiscal_Cel.webp"
    :escoT="false"
    :ejecT="true"
    :virtT="false" />

    <CalendarioOferta nombre="Maestría en Derecho Fiscal" 
  :inicios="[true, true, false, true, false, true, false, true]"></CalendarioOferta>
    <!-- <VerModelo esco=""
    ejec="/pagesImages/Programas/Maestria-ant/maestria-derecho-fiscal-ejecutivo.webp"
    :escoT="false"
    :ejecT="true"
    :virtT="false" /> -->

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-4 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block font-serif text-[42px] text-hgold text-left" style="">Estructura académica</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-xl text-left mb-3">(Bloques trimestrales):</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li><b>Bloque Corporativo:</b> Derecho corporativo, sociedades mercantiles y gobierno corporativo.</li>
                            <li><b>Bloque Fiscal:</b> Derecho tributario, obligaciones tributarias y recursos administrativos.</li>
                            <li><b>Bloque Procesal Fiscal:</b> Derecho procesal fiscal federal y CDMX, proceso administrativo del tribunal federal de justicia fiscal y administrativa.</li>
                            <li><b>Bloque Amparo y Delitos:</b> Juicio de amparo, materia fiscal y delitos fiscales.</li>
                            <li><b>Bloque Aduanero:</b> Derecho aduanero, aspectos tributarios del comercio exterior y precios de transferencia.</li>
                            <li><b>Seminario de titulación:</b> Desarrollo de un proyecto aplicado para la obtención del grado.</li>
                            <!-- <li><b>Seminario de Inteligencia Artificial.</b> Conocimiento, comprensión y aplicación de las herramientas de Inteligencia Artificial en entornos académicos, profesionales y laborales, fortaleciendo las habilidades y capacidades.</li> -->
                        </ul>
                        <!-- <p>
                            Este programa está diseñado para formar especialistas en contabilidad con una visión estratégica, capaces de responder a los desafíos del entorno fiscal, financiero y corporativo con un enfoque integral y actualizado.
                        </p> -->
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/hombre-mujer-maestria-estructura.webp" alt="Alt pendiente" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>

    <!-- <MtrModEjec class="mb-16" />

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Metodología</span>
                        </h2>
                        <p class="mb-4">
                            El modelo ejecutivo se desarrolla bajo la siguiente estructura:
                        </p>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Consta de 6 bloques trimestrales.</li>
                            <li>Cada bloque equivale a tres materias fusionadas, impartidas por un especialista en la materia.</li>
                            <li>Se imparten clases un día a la semana, tres horas de clases presenciales.</li>
                            <li>El modelo educativo tiene una duración de diez semanas de clases, y una semana adicional culminando con una evaluación final.</li>
                            <li>La evaluación se compone de participación en clase, foros, trabajos y examen final, integrando así un proceso de aprendizaje integral.</li>
                        </ul>
                        <p>
                            Este modelo permite a los estudiantes desarrollar habilidades especializadas con un enfoque práctico y estratégico, alineado con las exigencias del mundo profesional actual.
                        </p>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/universidad-fisica-virtual.webp" alt="Estudiantes de maestría en alta dirección corporativa universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section> -->
    
    <section class="lg:flex items-center justify-center bg-cover bg-[center] bg-no-repeat mb-16" style="background-image: url(/pagesImages/madin3.jpg); position: relative; background-attachment: fixed; background-position: left; background-repeat: no-repeat; background-size: cover; overflow: hidden; transition: transform 0.3s ease;">
        <div class="lg:flex items-center justify-center w-full h-full my-16">
            <div class="lg:flex items-center justify-between w-full max-w-[1200px]">
                <img src="/pagesImages/perfil-egresado-maestrias.webp" alt="Egresados de maestría de Derecho fiscal" class="lg:p-0 w-full lg:max-w-[520px] md:px-16 px-6 pt-6"/>
                <div class="flex flex-col lg:justify-start justify-center items-center lg:items-start lg:w-[50%] w-full lg:my-24 py-12 text-justify lg:px-0  px-8">
                    <h2>
                        <span class="block text-[28px] text-hwine leading-none text-center md:text-left">Perfil del egresado de la maestría en</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block text-hwine text-[42px] mb-4 leading-tight text-center md:text-left font-serif ">Derecho Fiscal</span>
                    </h2>
                    <p class="text-justify text-gray-800 lg:hyphens-manual hyphens-auto">Profesionales con una sólida formación teórico-práctica capaces de identificar, interpretar y aplicar los principios fundamentales del Derecho Fiscal. <br>El egresado está preparado para analizar el marco legal que regula la recaudación de impuestos, evaluar su impacto en los contribuyentes y diseñar estrategias fiscales que respondan a las necesidades del sector público y privado.</p>
                    <br>
                    <router-link to="/contacto">
                        <div class="flex items-center justify-center w-[140px] h-[35px] hover:bg-hwine bg-hgold text-white  text-lg transition duration-300 ease-in-out">
                            <span>Inscr&iacute;bete</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-4 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Cinco razones para elegir</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Universidad Humanitas:</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Modelo educativo especializado.</li>
                            <li>Excelencia académica.</li>
                            <li>Instalaciones de primer nivel.</li>
                            <li>Costos accesibles.</li>
                            <li>Acreditaciones reconocidas (SEP, ESR y GPTW).</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/beneficios-estudiar-universidad-humanitas.webp" alt="Beneficios de estudiar en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>
    <PoliticaIA />
</template>

<style scoped>
</style>